<template>
  <section id="deployment" ref="deploymentContent">
    <PageTitle :title="$t('blog.deployment.title')" :breadcrumbs="breadcrumbs"></PageTitle>
    
    <div class="wrapper wrapper-content animated fadeInRight">

      <Header></Header>

      <!-- TODO -->

    </div>
  </section>
</template>


<script lang="ts">
import { Component } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import GenericPage from '@fwk-client/components/mixins/GenericPage.vue';

import PageTitle from '@root/src/client/components/panels/PageTitle.vue';
import { enableIbox, disableIbox} from '@root/src/client/theme/inspinia-jquery'; 

import { useFeedAdmin } from '../../composables/useFeedAdmin';

import Header from '../panels/Header.vue';

@Component({
  components: {
    PageTitle,
    Header
  }
})
export default class Deployment extends mixins(GenericPage) {

  setup(props:any, context:any) {
    const { feeds, selectedFeed } = useFeedAdmin(props, context);
    return { feeds, selectedFeed }
  }

  get breadcrumbs() {
    return [{
      label: this.$t('home.dashboard')
    },
    {
      label: this.$t('blog.title')
    }]
  }

  mounted() {
    enableIbox(this.$refs.deploymentContent as HTMLElement);
  }

  beforeDestroy() {
    disableIbox(this.$refs.deploymentContent as HTMLElement);
  }

}
</script>